// @ts-nocheck
import { executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";
import loadProductByPath from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import loadVariantChildren from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import {
    chain,
    DispatchCompleteLoadProduct as baseDispatchCompleteLoadProduct,
    InitVariantProduct as baseInitVariantProduct,
    LoadProductIfNeeded as BaseLoadProductIfNeeded,
    RequestVariantChildrenFromApi as BaseRequestVariantChildrenFromApi,
    SetupVariantSelection,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { productIsMissingMandatoryExpands } from "@store/Framework/Common/Utilities/loadProductHelper";
import { getVariantChildrenDataView } from "@store/Modules/client-framework/src/Store/Data/Products/ProductsSelectors";
import {
    addToChainAfter,
    addToChainBefore,
    createChainHandler,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadProductIfNeeded = createChainHandler("LoadProductIfNeeded", chain, async props => {
    /* Store Custom Code - Start */
    const product = props.product;

    if (!product || product.isDiscontinued || productIsMissingMandatoryExpands(product)) {
        props.product = await executeAwaitableHandlerChain(
            loadProductByPath,
            { ...props.parameter, addToRecentlyViewed: true },
            props,
        );
    }
    /* Store Custom Code - End */
});

replaceInChain(chain, BaseLoadProductIfNeeded, LoadProductIfNeeded);

export const AfterLoadProductIfNeeded = createChainHandler("AfterLoadProductIfNeeded", chain, props => {
    if (props.product) {
        props.product = { ...props.product }; // Clone the object to prevent read-only errors
    }
});

addToChainAfter(chain, LoadProductIfNeeded, AfterLoadProductIfNeeded);

export const RequestVariantChildrenFromApi = createChainHandler("RequestVariantChildrenFromApi", chain, async props => {
    if (!props.product?.variantTraits || props.product.variantTraits.length === 0) {
        return;
    }

    props.variantChildren = getVariantChildrenDataView(props.getState(), props.product).value; // Store Custom Code
    if (!props.variantChildren) {
        props.variantChildren = await executeAwaitableHandlerChain(
            loadVariantChildren,
            { productId: props.product.id, product: props.product } as any, // Store Custom Code
            props,
        );
    }
});

replaceInChain(chain, BaseRequestVariantChildrenFromApi, RequestVariantChildrenFromApi);

export const BeforeSetupVariantSelection = createChainHandler("BeforeSetupVariantSelection", chain, props => {
    if (props.product && props.variantChildren) {
        // Tell the product it is a variant parent to allow the "getVariantSelection" to parse data properly.
        props.product.isVariantParent = true;
        // Since the "option" query string is not there, force it to the "productNumber" so it still understands which variant option is selected.
        (props.parameter as any).styledOption = props.parameter.styledOption || props.product.productNumber;
    }
});

addToChainBefore(chain, SetupVariantSelection, BeforeSetupVariantSelection);

export const AfterSetupVariantSelection = createChainHandler("AfterSetupVariantSelection", chain, props => {
    if (props.product && props.variantChildren) {
        // Tell the product it is no longer a variant parent to prevent display issues once the data is properly parsed by the "getVariantSelection" function.
        props.product.isVariantParent = false;
    }
});

addToChainAfter(chain, SetupVariantSelection, AfterSetupVariantSelection);

export const DispatchCompleteLoadProduct = createChainHandler("DispatchCompleteLoadProduct", chain, props => {
    if (!props.product) {
        return;
    }

    props.dispatch({
        type: "Pages/ProductDetails/CompleteLoadProduct",
        productInfosById: props.productInfosById ?? {},
        variantSelection: props.variantSelection ?? {},
        selectedProductId: props.product.id, // Store Custom Code
        configuration: props.product.detail?.configuration,
    });
});

replaceInChain(chain, baseDispatchCompleteLoadProduct, DispatchCompleteLoadProduct);

export const InitVariantProduct = createChainHandler("InitVariantProduct", chain, () => {
    // Store Removed - all code
});

replaceInChain(chain, baseInitVariantProduct, InitVariantProduct);
